import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { Panel, ACCENT } from "./ui";

// Activation = users who generated at least one quote / all registered users.
export default function ActivationDonut({ data, isLight }) {
  const { total, activated, not_activated, pct } = data;
  const track = isLight ? "rgba(15,23,42,0.08)" : "rgba(255,255,255,0.08)";
  const chart = total ? [{ name: "Ativados", value: activated }, { name: "Não ativados", value: not_activated }] : [{ name: "vazio", value: 1 }];
  return (
    <Panel title="Taxa de ativação" testid="chart-activation">
      <div className="flex items-center gap-5">
        <div className="relative h-36 w-36 shrink-0" data-testid="activation-donut">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={chart} dataKey="value" innerRadius={50} outerRadius={66} startAngle={90} endAngle={-270} paddingAngle={total && activated && not_activated ? 3 : 0} stroke="none" isAnimationActive>
                {chart.map((_, i) => <Cell key={i} fill={total ? (i === 0 ? ACCENT : track) : track} />)}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute inset-0 grid place-items-center pointer-events-none">
            <div className="text-center">
              <div className="text-2xl font-bold font-mono-jb text-white leading-none" data-testid="activation-pct">{String(pct).replace(".", ",")}%</div>
              <div className="mt-1 text-[10px] uppercase tracking-wider text-slate-400">ativados</div>
            </div>
          </div>
        </div>
        <div className="space-y-3 min-w-0">
          <div className="flex items-center gap-2.5">
            <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ background: ACCENT }} />
            <div><div className="text-[18px] font-semibold font-mono-jb text-white leading-none" data-testid="activation-activated">{activated}</div><div className="text-[11px] text-slate-400 mt-0.5">já geraram um orçamento</div></div>
          </div>
          <div className="flex items-center gap-2.5">
            <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ background: track }} />
            <div><div className="text-[18px] font-semibold font-mono-jb text-slate-300 leading-none" data-testid="activation-not">{not_activated}</div><div className="text-[11px] text-slate-400 mt-0.5">ainda não ativaram</div></div>
          </div>
          <div className="text-[11px] text-slate-500">de {total} cadastrados</div>
        </div>
      </div>
    </Panel>
  );
}
